import { createFileRoute } from '@tanstack/react-router';

import { KnowledgeBasePage } from '@/features/nis2/knowledge-base';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/nis2/knowledge-base')({
  beforeLoad: () => ({
    getTitle: () =>
      i18n.t('routeTitles.nis2KnowledgeBase', {
        defaultValue: 'NIS2 Knowledge Base',
        ns: 'common',
      }),
  }),
  component: KnowledgeBasePage,
});
